// extracted by mini-css-extract-plugin
export default {"headerText":"headerText-bjj7eX4c","row":"row-xWGqMGBR","iconLink":"iconLink-xvybDcJq","icon":"icon-ZIgC8GdE"};